import { useI18n } from "@/i18n";

export const AiBadge = () => {
  const { t } = useI18n();
  return (
    <span
      data-testid="ai-badge"
      className="inline-flex h-6 items-center rounded-[8px] border border-[rgba(13,148,136,0.3)] px-2 font-mono text-[13px] uppercase leading-[18px] text-ax-link"
    >
      {t("ai.badge")}
    </span>
  );
};

export const AiBlock = ({ title, children, testId }) => (
  <section data-testid={testId} className="tint-ai rounded-[12px] p-4">
    <AiBadge />
    {title && <h3 className="m-0 mt-3 text-base font-semibold leading-6 text-ax-text">{title}</h3>}
    <div className={title ? "mt-2" : "mt-3"}>{children}</div>
  </section>
);
